const getBusinessDescription = (rootState) => rootState.ws.site.properties.businessDescription;

export default getBusinessDescription;
